module.exports = __webpack_public_path__ + "static/small-ecommerce-mobile.ed9f8597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/small-ecommerce-mobile.jpg
// module id = 674
// module chunks = 35783957827783